import { RefObject, useEffect, useState } from 'react';

import { useBannerStatus } from './useBannerStatus';

export const usePageHeight = (subtractHeight: number = 0, refs?: RefObject<HTMLElement>[]) => {
  const [refsHeight, setRefsHeight] = useState(0);

  useEffect(() => {
    if (!refs?.length) return;

    const calculateHeights = () => {
      const totalHeight = refs.reduce((sum, ref) => {
        if (ref.current) {
          const { height } = ref.current.getBoundingClientRect();
          return sum + height;
        }
        return sum;
      }, 0);
      setRefsHeight(totalHeight);
    };

    calculateHeights();

    // ResizeObserver를 사용하여 요소 크기 변경 감지
    const resizeObserver = new ResizeObserver(calculateHeights);
    refs.forEach((ref) => {
      if (ref.current) {
        resizeObserver.observe(ref.current);
      }
    });

    return () => {
      resizeObserver.disconnect();
    };
  }, [refs]);

  const { bannerHeight } = useBannerStatus();
  const totalHeight = bannerHeight + subtractHeight + refsHeight;

  return `calc(100vh - ${totalHeight}px)`;
};
